/**
 * בסיס URL ל-API – בשרת (server/src/app.js) כל הראוטים תחת ‎/api/...
 * אם ב-.env רק origin בלי ‎/api‎, בקשות כמו POST ‎/auth/request-otp‎ נוחתות על ‎/auth/...‎ ומקבלות 404.
 */
export function getApiBaseUrl() {
  const raw = (import.meta.env.VITE_API_URL || "").trim();
  const fallback = "https://api.reshet.app/api";
  if (!raw) return fallback;

  const base = raw.replace(/\/+$/, "");
  if (/\/api$/i.test(base)) return base;

  try {
    const u = new URL(base);
    const path = (u.pathname || "/").replace(/\/+$/, "") || "/";
    if (path === "/") {
      return `${u.origin}/api`;
    }
  } catch {
    return `${base}/api`;
  }

  // URL עם path מותאם (לא רק /) – לא מניחים מבנה; מחזירים כמו שהוגדר
  return base;
}
